import { boolean, mixed, number, object, string } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { addressLookupSchema } from "@shared-kernel/primary/forms/validations/postal-address.schema";
import { MAX_STUDIO_PRICE, MIN_STUDIO_PRICE } from "@academy-context/write/domain/constants/shared";
import { EUROPEAN_COUNTRIES } from "@shared-kernel/domain/types/supported-country";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { STUDIO_OPTION } from "./shared";
import type { StudioDetails } from "./shared";
import { studioEnvironmentSchema } from "@academy-context/primary/shared/studio-environment/studio-environment.schema";

// ============================================================================
// Studio Step Schema (Step 2)
// ============================================================================

export const studioStepSchema = object({
  studio: object({
    option: mixed<STUDIO_OPTION>()
      .required("Le type de studio est requis")
      .oneOf(Object.values(STUDIO_OPTION), "Le type de studio est requis"),
    studioId: string().when("option", {
      is: STUDIO_OPTION.PARTNER,
      then: schema => schema.required("Sélectionnez un studio"),
      otherwise: schema => schema.nullable(),
    }),
    details: object().when("option", {
      is: (value: STUDIO_OPTION) => value === STUDIO_OPTION.PERSONAL || value === STUDIO_OPTION.OTHER,
      then: () =>
        object({
          name: string().required("Le nom du studio est requis").max(255),
          postalAddress: addressLookupSchema,
          addressComplement: string().max(255).defined(),
          country: string().required(REQUIRED_FIELD).oneOf(EUROPEAN_COUNTRIES, "Le pays doit être en Europe"),
          equipmentDescription: string().required("La description des moyens techniques est requise"),
          price: number()
            .typeError(`Le tarif doit être compris entre ${MIN_STUDIO_PRICE}€ et ${MAX_STUDIO_PRICE}€`)
            .min(MIN_STUDIO_PRICE, `Le tarif doit être compris entre ${MIN_STUDIO_PRICE}€ et ${MAX_STUDIO_PRICE}€`)
            .max(MAX_STUDIO_PRICE, `Le tarif doit être compris entre ${MIN_STUDIO_PRICE}€ et ${MAX_STUDIO_PRICE}€`)
            .required("Le tarif est requis"),
          isMobilityAccessible: boolean().required(),
          environment: studioEnvironmentSchema,
        }),
      otherwise: schema => schema.nullable(),
    }),
  }).required(),
});

export type StudioStepInputs = {
  studio: {
    option: STUDIO_OPTION | undefined;
    studioId: Nullable<string>;
    details: Nullable<StudioDetails>;
  };
};
